export function jwtSignature() {
  return `${process.env.JWT_SIGNATURE}`;
}
